import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { registerAppServiceWorker } from "../shared/app-update";

registerAppServiceWorker("#0f766e");

const rootEl = document.getElementById("portail-root");
if (!rootEl) throw new Error("Root element #portail-root not found");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);
